export const borderColors = ['#B961FF', '#61C6FF', '#FFA361', '#3CCDC4'];

export const checkIfAnyStageHasApplications = (arr) => {
  for (let i = 0; i < arr.length; i++) {
    if (arr[i].applications && arr[i].applications.length > 0) {
      return true;
    }
  }
  return false;
};

export const getAllApplications = (arr) => {
  return arr?.reduce(
    (acc, curr) => [
      ...acc,
      ...curr?.applications?.map((app) => ({
        appId: app?.id,
        ...app?.contact,
      })),
    ],
    []
  );
};
